import React from 'react';
import { connect } from 'react-redux';

import { doGet } from '@modules/DataManager';
import { isInRole } from '@modules/utils';

import s from './profile.module.scss';

const mapStateToProps = (state) => ({ user: state.user });

const EMPTY = { transato: '0', viaggi: 0 };
const EMPTY_BASES = { created: EMPTY, booking: EMPTY };

/** Normalizza un report di base ({transato, viaggi}) garantendo transato stringa. */
const normBase = (b) => {
  if (!b) return EMPTY;
  const transato = b.transato != null ? String(b.transato) : '0';
  return { transato, viaggi: b.viaggi ?? 0 };
};

/**
 * Normalizza la risposta backend.
 * - Nuovo shape: `{ created:{transato,viaggi}, booking:{...} }`.
 * - Vecchio shape (backend non ancora aggiornato): `{ transato, viaggi }` →
 *   stesso valore su entrambe le basi, così la UI mostra comunque le cifre.
 */
const normBases = (res) => {
  if (!res) return EMPTY_BASES;
  if (res.created || res.booking) {
    return { created: normBase(res.created), booking: normBase(res.booking) };
  }
  const same = normBase(res);
  return { created: same, booking: same };
};

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oggi: EMPTY_BASES,
      mese: EMPTY_BASES,
      loading: false,
    };
    this.onOpen = this.onOpen.bind(this);
  }

  onOpen() {
    const u = this.props.user;
    if (!u || this.state.loading) return;
    this.setState({ loading: true });

    Promise.all([
      doGet('/analytics/report-user-month', { user_id: u.id }),
      doGet('/analytics/report-user-day', { user_id: u.id }),
    ])
      .then(([month, day]) => {
        this.setState({ mese: normBases(month), oggi: normBases(day) });
      })
      .finally(() => this.setState({ loading: false }));
  }

  renderRow(label, bases) {
    return (
      <div className={s.row}>
        <span className={s.rowLabel}>{label}</span>
        <div className={s.bases}>
          <div className={s.base}>
            <span className={s.baseTag}>Viaggio</span>
            <span className={s.baseValue}>
              {bases.booking.transato}€ · {bases.booking.viaggi} vg
            </span>
          </div>
          <div className={s.base}>
            <span className={s.baseTag}>Creato</span>
            <span className={s.baseValue}>
              {bases.created.transato}€ · {bases.created.viaggi} vg
            </span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const u = this.props.user;
    const av = u ? u.nome.charAt(0) + u.cognome.charAt(0) : '';
    const canSeeStats = isInRole(['admin', 'super', 'administrative']);

    return (
      <div className={s.profileMenu} onMouseOver={this.onOpen} onFocus={this.onOpen}>
        <div className={s.topIcons}>
          <div className={s.avatar}>{av}</div>
        </div>

        <div className={s.services}>
          <div className={s.servicesContainer}>
            <div className={s.arrowUp} />

            {canSeeStats && (
              <>
                {this.renderRow('OGGI', this.state.oggi)}
                {this.renderRow('MESE', this.state.mese)}
              </>
            )}

            <button
              type="button"
              className={s.logout}
              onClick={() => window.firebase.auth().signOut()}
            >
              LOGOUT
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(Profile);
